import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
// import { environment } from '@environments/environment';
import { SITE_LINKS } from '@shared/constants/site-links.constants';
import { STORAGE } from '@shared/constants/storage.constants';
import { StorageService } from '@shared/services/storage/storage.service';
import { buildUrl } from '@shared/utilities/common.utils';

export const authGuard: CanActivateFn = (route, state) => {
  const storageService = inject(StorageService);
  const router = inject(Router);

  if (!storageService.get(STORAGE.ACCESS_TOKEN)) {
    // console.log('Access Denied, Login is Required to Access This Page!');
    router.navigateByUrl(buildUrl(SITE_LINKS.AUTH.LOGIN, 'residential'));
  }
  return true;
};
